<template>
  <div class="data-list-container vs-con-loading__container">
    <vs-table
      ref="table"
      @selected="handleSelected"
      :max-items="itemsPerPage"
      :data="data">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <vs-card class="cardx">
          <vs-row vs-w="12">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="9"
              vs-xs="8">
              <vs-input
                texarea
                placeholder="IMEI"
                name="name"
                v-model="imei"
                class="w-full" />
              <!--<vs-chips color="rgb(145, 32, 159)" placeholder="IMEI Number" v-model="chips">-->
              <!--<vs-chip-->
              <!--:key="chip"-->
              <!--@click="remove(chip)"-->
              <!--v-for="chip in chips" closable>-->
              <!--{{ chip }}-->
              <!--</vs-chip>-->
              <!--</vs-chips>-->
              <small>*Using space as separator between IMEI </small>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="2"
              vs-xs="3">
              <vs-button
                @click="search()"
                class="w-full shadow float-left"
                type="gradient"
                color="#d23030"
                gradient-color-secondary="#f89595"
                >Search
              </vs-button>
            </vs-col>
            <vs-col
              v-if="data.length > 0"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="1"
              vs-xs="1"
              style="padding: 0">
              <download-excel :data="data">
                <vs-button
                  class="w-full shadow"
                  type="gradient"
                  color="#d23030"
                  gradient-color-secondary="#f89595">
                  <feather-icon
                    svgClasses="h-4 w-4"
                    class="cursor-pointer"
                    icon="DownloadIcon"></feather-icon>
                </vs-button>
              </download-excel>
            </vs-col>
          </vs-row>
        </vs-card>

        <!--<vs-select id="selectFleet"  placeholder="- Select -" v-model="selected_fleet" label="Fleet Group" class="cursor-pointer mb-4 mr-4">-->
        <!--<vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in fleetData" />-->
        <!--</vs-select>-->
        <!-- ITEMS PER PAGE -->
      </div>

      <template slot="thead">
        <vs-th>IMEI</vs-th>
        <vs-th>Vehicle Number</vs-th>
        <vs-th>Latitude</vs-th>
        <vs-th>Longitude</vs-th>
        <vs-th>Device Time</vs-th>
        <vs-th>Status</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody id="isi_table">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].imei">
              <p class="product-name font-medium">{{ tr.imei }}</p>
            </vs-td>
            <vs-td :data="data[indextr].vehicle_number">
              <p class="product-name font-medium">{{ tr.vehicle_number }}</p>
            </vs-td>
            <vs-td :data="data[indextr].latitude">
              <p class="product-name font-medium">{{ tr.latitude }}</p>
            </vs-td>
            <vs-td :data="data[indextr].longitude">
              <p class="product-name">{{ tr.longitude }}</p>
            </vs-td>

            <vs-td :data="data[indextr].device_time">
              <p class="product-name">{{ tr.device_time }}</p>
            </vs-td>
            <vs-td :data="data[indextr].status">
              <p class="product-name font-medium" v-if="tr.status == 'loading'">
                On Progress...
              </p>
              <p
                class="product-name font-medium"
                v-if="tr.status == 'failed'"
                style="font-weight: bold; color: red">
                failed
              </p>
              <p
                class="product-name font-medium"
                v-if="tr.status == 'success'"
                style="font-weight: bold; color: #0cb603">
                <a
                  target="_blank"
                  :href="
                    'http://www.google.com/maps/place/' +
                    tr.latitude +
                    ',' +
                    tr.longitude
                  "
                  >Show Map</a
                >
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <template>
      <vs-pagination :total="last_page" v-model="page"></vs-pagination>
    </template>
  </div>
</template>

<script>
import * as REPO from '../../repository/index'
import { getListFleetGroup } from '../../repository/index'
import moment from 'moment'

export default {
  components: {},
  beforeRouteLeave(to, from, next) {
    this.closeModal()
    setTimeout(() => {
      next()
    }, 100)
  },
  data() {
    return {
      chips: [],
      openModal: false,
      editMode: false,
      titleModal: 'Add New',
      selected: [],
      dataEdit: {},
      fleetData: [],
      data: [],
      roleData: [],
      itemsPerPage: 10,
      last_page: 1,
      page: 1,
      imei: '',
      search_name: '',
      access_token: '',
      counter: 0,
      max_lengtH: 0,
      selected_fleet: '',
      isMounted: false,
      addNewDataSidebar: false,
    }
  },
  watch: {},
  computed: {},
  methods: {
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1)
    },
    addNew() {
      this.editMode = false
      this.titleModal = 'Add New'
      this.dataEdit = {}
      this.openModal = true
    },

    getCredential() {
      REPO.loginMW()
        .then((res) => {
          this.access_token = res.data.access_token
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        })
        .catch((err) => {
          //
          this.$toast.error(err.message)
        })
    },
    search() {
      // REPO.refreshToken().then(res=>{
      //
      //     let payload = {
      //         token:res.data.data.token
      //     }
      //     this.$store.dispatch('auth/reloadStorage', payload)
      //
      // });
      let tmp = this.imei.split(' ')
      let hasil = []
      tmp.forEach((x) => {
        hasil.push({
          imei: x,
          vehicle_number: '',
          latitude: '',
          longitude: '',
          device_time: '',
          status: '',
        })
      })
      this.counter = 0
      this.data = hasil
      this.startSearch(0)
      //
    },
    startSearch(val) {
      this.data[this.counter].status = 'loading'
      REPO.getOneLastPosition(this.data[this.counter].imei, this.access_token)
        .then((res) => {
          this.data[this.counter].latitude =
            res.data.data[0].attributes.latitude
          this.data[this.counter].longitude =
            res.data.data[0].attributes.longitude
          this.data[this.counter].vehicle_number =
            res.data.data[0].attributes.vehicle_number
          this.data[this.counter].device_time = moment(
            res.data.data[0].attributes.device_time
          ).format('DD MMM YYYY HH:MM')
          this.data[this.counter].status = 'success'
          this.counter++
          if (this.counter < this.data.length) {
            this.startSearch(0)
          }
        })
        .catch((err) => {
          this.data[this.counter].status = 'failed'
          this.counter++
          if (this.counter < this.data.length) {
            this.startSearch(0)
          }
        })
    },
    statusDescription(val) {
      if (val == 1) {
        return 'Active'
      } else {
        return 'Non Active'
      }
    },
    handleSelected(tr) {
      this.editMode = true
      this.titleModal = 'Update Data'
      this.dataEdit = JSON.parse(JSON.stringify(tr))
      this.openModal = true
    },
    closeModal() {
      this.openModal = false
    },
    submitModal() {
      this.openModal = false
      this.getData()
    },
    getStatusColor(status) {
      if (status == '0') return 'danger'
      if (status == '1') return 'success'
      return 'primary'
    },
    getPopularityColor(num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    formatData(data) {
      // formats data received from API
      let formattedData = data.map((item) => {
        const fields = item.fields
        let obj = {}
        for (const key of Object.keys(fields)) {
          obj[key] =
            fields[key].stringValue ||
            fields[key].integerValue ||
            fields[key].doubleValue
        }
        return obj
      })
      return formattedData
    },
  },
  created() {
    this.getCredential()
  },
  mounted() {
    this.$vs.loading({
      container: '#data-list-list-view',
      scale: 1,
    })
    this.isMounted = true
  },
}
</script>

<style lang="scss" scoped>
.con-chips .con-vs-chip {
  margin: 2px !important;
}
</style>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
